import { VStack } from "_ui/Box";
import { Page } from "_page/Page";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "_layout/Client/Footer";
import { LimitedWidth } from "_page/LimitedWidth";
import { ToastProvider } from "_components/ToastProvider";


export const DefaultLayout = () => {
    return (
        <VStack>
            <Header />
            <Page style={{ minHeight: 'calc(100vh - 199px)' }}>
                <ToastProvider />
                <LimitedWidth>
                    <VStack center wFullVw alignCenter>
                        <Outlet />
                    </VStack>
                </LimitedWidth>
            </Page>

            <Footer />
        </VStack>
    )
}
